import { UserApiService, UserDetailsResponse } from "../../shared/service-proxies/service-proxies";

export interface UserManagerSettings {
  loginUrl: string;
  loginOutUrl: string;
}

export class UserManager {
  _userApiService: UserApiService;
  _settings: UserManagerSettings;
  _user: UserDetailsResponse = null;

  constructor(settings: UserManagerSettings, userApiService: UserApiService) {
    this._settings = settings;
    this._userApiService = userApiService;
  }

  getUserDetails(): Promise<UserDetailsResponse> {
    return new Promise((resolve, reject) => {
      this._userApiService.getUser().subscribe(user => {
        this._user = user;
        resolve(user);
      }, err => {
        resolve(null);
      });
    });
  }

  getUser(): Promise<UserDetailsResponse> {
    return new Promise((resolve, reject) => {
      resolve(this._user);
    });
  }
}
